import { Component, Input, OnInit } from '@angular/core';
import { ProprieteHelper } from '../../modeles/ProprieteHelper';
import { EditerFichePropriete } from '../../propriete.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ProprieteModele } from '../../modeles/proprieteModel';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';

@Component({
  selector: 'app-property-details-fees',
  templateUrl: './property-details-fees.component.html',
  styleUrls: ['./property-details-fees.component.scss'],
  standalone: false
})
export class PropertyDetailsFeesComponent implements OnInit {
  @Input() currentProperty: ProprieteHelper;

  donneesEtapeMiseFonds$: Observable<any> = this._toolCapaciteService.donneesEtapeMiseFonds$;

  showPropertyFees = false;
  miseDeFondDescriptionPart1: string;
  miseDeFondDescriptionPart2: string;

  constructor(private readonly _store: Store, private readonly _toolCapaciteService: ToolCapaciteService) {}
  ngOnInit() {
    this.miseDeFondDescriptionPart1 = 'propriete.detail.frais.prime-assurance.tooltip.description.part-1';
    this.miseDeFondDescriptionPart2 = 'propriete.detail.frais.prime-assurance.tooltip.description.part-2';
  }
  editProperty(): void {
    const currentProperty: ProprieteModele = this.currentProperty.propriete;
    this._store.dispatch(new EditerFichePropriete(currentProperty.id, 'propriete/detail/' + currentProperty.id));
  }
  getTextMiseDeFond(miseDeFond: string, text1: string, text2: string) {
    return Number(miseDeFond) < this.currentProperty.prixTotal * 0.2 ? text1 + text2 : text2;
  }

  getBackgroundImageSource() {
    return {
      desktop: '/background-du-tiroir-ouvert.svg'
    };
  }
}
